// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"GigAssClose_closeButton__U7JxV"};